import React from 'react';

import { MODALS, BROADCAST_STATUS, NOTIFY_NOTE_CONTENT } from '../utils/constants';
function isSubmitted(note) {
    return note.status === BROADCAST_STATUS.submitted;
}

function BroadcastNotes({ notes, setModalOpen }) {
    return (
        <div className="card">
            <div className="card__account-header">
                <h2 className="card__title">Notes</h2>
                <div>
                    <button
                        className="mdl-button mdl-button--raised button-blue"
                        onClick={() => setModalOpen(MODALS.broadcastNote)}
                        style={{ minWidth: '150px', float: 'right', marginBottom: '12px' }}>
                        Add note
                    </button>
                </div>
            </div>
            {notes.map((note, i) => (
                <div className={isSubmitted(note) ? "card card__submitted" : "card"}
                    key={`${note.content.slice(0, 5)}-${i}`}>
                    <div style={{marginBottom: '10px', display: 'flex' }}>
                        {isSubmitted(note) && (
                            <React.Fragment>
                                <span className="material-icons card__submitted-icon">
                                    done
                                </span>
                                {NOTIFY_NOTE_CONTENT}
                            </React.Fragment>
                        )}
                    </div>
                    {(!isSubmitted(note) || note.content !== NOTIFY_NOTE_CONTENT) && (
                        <div style={{whiteSpace: 'pre-line', marginBottom: '10px', color: 'black', fontWeight: 'normal'}}>
                            {note.content}
                        </div>
                    )}
                    <div className="mdl-color-text--grey-600" style={{fontSize: '12px', fontWeight: 'normal'}}>
                        {`${note.createdAtFormatted} ${note.createdBy}`}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default BroadcastNotes;
